import React from 'react';
import { Link } from 'react-router-dom';
import { Home, AlertCircle } from 'lucide-react';
import { SEO } from '../components/SEO';

function NotFound() {
  return (
    <>
      <SEO 
        title="404 Stranica Nije Pronađena | Online Kalkulator"
        description="Stranica koju tražite nije pronađena. Vratite se na početnu stranicu i pronađite željeni kalkulator."
        canonicalUrl="/404"
      />
      <div className="min-h-[80vh] flex items-center justify-center px-4">
        <div className="max-w-md w-full text-center">
          <div className="mb-8">
            <AlertCircle className="w-20 h-20 text-blue-600 mx-auto" />
          </div>
          
          <h1 className="text-4xl font-bold text-gray-800 mb-4">
            404 - Stranica Nije Pronađena
          </h1>
          
          <p className="text-gray-600 mb-8">
            Stranica koju tražite ne postoji ili je premještena.
            Molimo vas da provjerite URL ili se vratite na početnu stranicu.
          </p>
          
          <Link
            to="/"
            className="inline-flex items-center px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition"
          >
            <Home className="w-5 h-5 mr-2" />
            Početna Stranica
          </Link>
          
          <div className="mt-8 pt-8 border-t border-gray-200">
            <h2 className="text-lg font-semibold text-gray-700 mb-4">
              Popularne Stranice
            </h2>
            <div className="grid grid-cols-2 gap-4">
              <Link
                to="/pdv-kalkulator"
                className="p-3 text-gray-600 hover:text-blue-600 hover:bg-gray-50 rounded-lg transition"
              >
                PDV Kalkulator
              </Link>
              <Link
                to="/izracun-postotka"
                className="p-3 text-gray-600 hover:text-blue-600 hover:bg-gray-50 rounded-lg transition"
              >
                Izračun Postotka
              </Link>
              <Link
                to="/kalkulator-place"
                className="p-3 text-gray-600 hover:text-blue-600 hover:bg-gray-50 rounded-lg transition"
              >
                Kalkulator Plaće
              </Link>
              <Link
                to="/kalkulator-kredita"
                className="p-3 text-gray-600 hover:text-blue-600 hover:bg-gray-50 rounded-lg transition"
              >
                Kalkulator Kredita
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default NotFound;